import { render, staticRenderFns } from "./EditResourceDialog.vue?vue&type=template&id=0e241244&scoped=true"
import script from "./EditResourceDialog.vue?vue&type=script&lang=js"
export * from "./EditResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditResourceDialog.vue?vue&type=style&index=0&id=0e241244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e241244",
  null
  
)

export default component.exports